<template>
  <modal
    name="address-modal"
    @before-close="beforeClose"
    :adaptive="true"
    :shiftX="language == 'ar' ? 0 : 0.5"
    height="auto"
    :scrollable="true"
  >
    <div class="closeButton">
      <el-button
        icon="el-icon-circle-close"
        @click.prevent="$modal.hide('address-modal')"
        round
      >
      </el-button>
    </div>

    <form @submit.prevent="saveDetails" id="address-modal">
      <div class="form__field">
        <label><strong>{{ __('Full Name') }}</strong></label>
        <input
          type="text"
          v-model="form.name"
          class="form__input form__input--secondary"
          :placeholder="__('Full Name')"
        />
        <span class="error" v-if="form.errors.has('name')">{{
          form.errors.get("name")
        }}</span>
      </div>

      <div class="form__field">
        <label><strong>Telephone</strong></label>
        <input
          type="tel"
          v-model="form.telephone"
          class="form__input form__input--secondary"
          placeholder="Phone number"
        />
        <span class="error" v-if="form.errors.has('telephone')">{{
          form.errors.get("telephone")
        }}</span>
      </div>

      <div class="form__field">
        <label><strong>Address Line 1</strong></label>
        <input
          type="text"
          v-model="form.address_1"
          class="form__input form__input--secondary"
          placeholder="Address Line 1..."
        />
        <span class="error" v-if="form.errors.has('address_1')">{{
          form.errors.get("address_1")
        }}</span>
      </div>

      <div class="form__field">
        <label><strong>Address Line 2</strong></label>
        <input
          type="text"
          v-model="form.address_2"
          class="form__input form__input--secondary"
          placeholder="Address Line 2..."
        />
        <span class="error" v-if="form.errors.has('address_2')">{{
          form.errors.get("address_2")
        }}</span>
      </div>

      <div class="form__field">
        <label><strong>Town/City</strong></label>
        <input
          type="text"
          v-model="form.town"
          class="form__input form__input--secondary"
          placeholder="City..."
        />
        <span class="error" v-if="form.errors.has('town')">{{
          form.errors.get("town")
        }}</span>
      </div>

      <div class="form__field">
        <label><strong>County</strong></label>
        <input
          type="text"
          v-model="form.county"
          class="form__input form__input--secondary"
          placeholder="County..."
        />
        <span class="error" v-if="form.errors.has('county')">{{
          form.errors.get("county")
        }}</span>
      </div>

      <div class="form__field">
        <label><strong>Postcode</strong></label>
        <input
          type="text"
          v-model="form.postcode"
          class="form__input form__input--secondary"
          placeholder="Postcode..."
        />
        <span class="error" v-if="form.errors.has('postcode')">{{
          form.errors.get("postcode")
        }}</span>
      </div>

      <div class="form__field">
        <label>
          <input v-model="form.is_default_delivery" type="checkbox" />
          Default delivery address
        </label>
      </div>

      <div class="form__field">
        <label>
          <input v-model="form.is_default_billing" type="checkbox" />
          Default billing address
        </label>
      </div>

      <div class="form__field">
        <button type="submit" :disabled="form.busy" class="btn btn--quaternary">
          {{ form.busy ? "Please wait..." : "Save Details" }}
        </button>

        <button
          type="button"
          :disabled="form.busy"
          @click.prevent="deleteAddress"
          v-if="isEdit"
          class="btn btn--secondary"
        >
          {{ form.busy ? "Please wait..." : "Delete" }}
        </button>
      </div>
    </form>
  </modal>
</template>

<script>
import { Form } from "vform";
export default {
  props: {
    language: {
      required: false,
      default: function() {
        return 'en';
      }
    }
  },
  data() {
    return {
      isEdit: false,
      form: new Form({
        id: false,
        name: "",
        address_1: "",
        address_2: "",
        county: "",
        town: "",
        postcode: "",
        email: "",
        telephone: "",
        country: "",
        is_default_delivery: false,
        is_default_billing: false,
      }),
    };
  },
  created() {
    this.$root.$on("edit-address", this.setAddress);
  },
  methods: {
    setAddress(address) {
      this.form.fill(address);
      this.isEdit = true;
    },
    beforeClose() {
      this.form.reset();
    },
    saveDetails() {
      this.form.post("/account/details").then((response) => {
        this.$modal.hide("address-modal");

        window.location.reload();
      });
    },
    deleteAddress() {
      this.form.delete("/account/details/" + this.form.id).then(() => {
        this.$modal.hide("address-modal");
        window.location.reload();
      });
    },
  },
};
</script>

<style scoped>
form {
  padding: 40px;
}
.error {
  display: block;
  color: red;
  margin: 10px 0px;
}
.closeButton {
  position: absolute;
  right: 10px;
  top: 10px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/Account/address-modal.vue